import styled from 'styled-components';



export const SocialMediaIcons = styled.div`
  display: flex;
  gap: 1.5rem;
  margin-top: 1rem;
`;

export const SocialMediaIcon = styled.a`
  display: inline-block;
  margin: 0 1rem;
  font-size: 1.5rem;
  color: ${({ theme }) => theme.text_primary};
  transition: color 0.2s ease-in-out;
  &:hover {
    color: ${({ theme }) => theme.primary};
  }
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 4rem 2rem;
  background: ${({ theme }) => theme.bg};
  color: ${({ theme }) => theme.text_primary};
`;

export const ProfileImage = styled.img`
  width: 180px;
  height: 180px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 2rem;
`;

export const Heading = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 1rem;
`;

export const Paragraph = styled.p`
  max-width: 600px;
  font-size: 1.1rem;
  margin-bottom: 1rem;
  line-height: 1.6;
`;

export const Button = styled.a`
  display: inline-block;
  margin-top: 1rem;
  padding: 0.75rem 1.5rem;
  background: ${({ theme }) => theme.primary};
  color: #fff;
  border-radius: 4px;
  text-decoration: none;
  font-weight: bold;
  transition: background 0.3s ease;

  &:hover {
    background: ${({ theme }) => theme.primary + 'CC'};
  }
`;
